import axios from 'axios';

export default {
  async getCustomFields(matterId: string) {
    const { data } = await axios.get(`/matters/${matterId}/customfields`);
    return data;
  },

  async updateCustomFields(matterId: string, customFields: unknown[]) {
    const { data } = await axios.put(`/matters/${matterId}/customfields`, {
      customFields,
    });
    return data;
  },

  async bulkChangeResponsible(ids: string[], accountId: string) {
    const { data } = await axios.post('/matters/bulk-change-responsible', { ids, accountId });
    return data;
  },

  async bulkArchive(ids: string[], archive: boolean) {
    const { data } = await axios.post('/matters/bulk-archive', { ids, archive });
    return data;
  },

  async bulkApplyRateGroup(ids: string[], rateGroupId: string, updateEntries: boolean) {
    const { data } = await axios.post('/matters/bulk-apply-rate-group', { ids, rateGroupId, updateEntries });
    return data;
  },

  async bulkUpdateLedes(ids: string[], enabled: boolean, format: string | null) {
    const { data } = await axios.post('/matters/bulk-update-ledes', { ids, enabled, format });
    return data;
  },
};
